import React from "react";
import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import { MdPlaylistAdd } from "react-icons/md";

import styles from "./ComplexOrder.module.scss";
import { useComplexOrder } from "./useComplexOrder";
import { PageHeader } from "../../../common/components/pageHeader/PageHeader";
import { EmptyState } from "../../../common/components/emptyState/EmptyState";
import { StatusChip } from "../../../common/components/statusChip/StatusChip";
import {
  getComplexOrderStatusText,
  getComplexOrderStatusTextColor,
} from "../../../common/utils/functions/enumToText";
import { ComplexOrderStatus } from "../../../common/types/enums";
import { ComplexOrderItem } from "./ComplexOrderItem";
import { PROFILE_ROUTE } from "../../../common/utils/constants";

const STATUSES = [
  ComplexOrderStatus.DRAFT,
  ComplexOrderStatus.SENT_TO_MANAGER,
  ComplexOrderStatus.IN_PROGRESS,
  ComplexOrderStatus.APPROVED,
  ComplexOrderStatus.CONVERTED,
  ComplexOrderStatus.ARCHIVED,
];

export const ComplexOrder: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { orders, status, ready, isFetchingMore, isEmpty, lastItemRef } =
    useComplexOrder();

  const handleStatusSelect = (value: ComplexOrderStatus | null) => {
    const params = new URLSearchParams(searchParams);
    if (value === null) {
      params.delete("status");
    } else {
      params.set("status", String(value));
    }
    setSearchParams(params);
  };

  return (
    <div className={styles.Page}>
      <Helmet>
        <title>Мои проекты — ЛОГМОЛЛ</title>
      </Helmet>

      <PageHeader title="Мои проекты" backRoute={PROFILE_ROUTE} />

      <div className={styles.Filters}>
        <StatusChip
          label="Все"
          isActive={status === undefined}
          onClick={() => handleStatusSelect(null)}
          compact
        />
        {STATUSES.map((s) => (
          <StatusChip
            key={s}
            label={getComplexOrderStatusText(s)}
            color={getComplexOrderStatusTextColor(s)}
            isActive={status === s}
            onClick={() => handleStatusSelect(status === s ? null : s)}
            compact
          />
        ))}
      </div>

      {!ready ? (
        <div className={styles.Loader}>Загрузка...</div>
      ) : isEmpty ? (
        <EmptyState
          icon={MdPlaylistAdd}
          title="Проектов пока нет"
          description="Добавьте товары в проект из каталога."
        />
      ) : (
        <>
          <div className={styles.List}>
            {orders.map((order, index) => (
              <ComplexOrderItem
                key={order.id}
                order={order}
                lastItemRef={
                  index === orders.length - 1 ? lastItemRef : undefined
                }
              />
            ))}
          </div>

          {isFetchingMore && <div className={styles.Loader}>Загрузка...</div>}
        </>
      )}
    </div>
  );
};
